import React from 'react';

import WizardWorkflowTemplatesList from '~/components/Workflow/WorkflowTicketsPage/TicketCreatePage/WizardWorkflowTemplatesList/WizardWorkflowTemplatesList';
import { ContentContainer } from '~/eds/src/components/ContentContainer/ContentContainer';
import { api } from '~/redux/api/createApi';
import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';

const Page = () => {
  const { navigate } = useRouting();

  const { data: templates, isLoading: isTemplatesLoading } =
    api.endpoints.getAvailableWorkflows.useQuery({});

  const handleClose = () => {
    navigate(RoutePathType.WorkflowTickets);
  };

  return (
    <ContentContainer
      loadingContent={{
        isLoading: isTemplatesLoading,
      }}
    >
      <WizardWorkflowTemplatesList
        templatesData={templates || []}
        hideModal={handleClose}
      />
    </ContentContainer>
  );
};

export default Page;
